import { useContext, useState } from 'react';

import styled from '@emotion/styled';

import PrimaryButton, {
  FormSubmitButton,
} from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import {
  TextAreaInputField,
  TextInputField,
} from '../../components/FormCom/FormField';
import SuccessCheckMarkIcon from '../../components/Icons/SuccessCheckMarkIcon';
import { ModalContentWrapper } from '../../components/Modal/ModalContentWrapper';
import { ModalContext } from '../../Context/ModalContext';
import {
  ReportIssueDataType,
  reportIssueInitialValues,
  ReportIssueSchema,
} from '../../model/reportIssue.model';

const ReportIssueModal = () => {
  const modalContext = useContext(ModalContext);
  const [successBanner, showSuccessBanner] = useState(false);

  const onSubmit = async (values: ReportIssueDataType) => {
    alert(JSON.stringify(values));
    showSuccessBanner(!successBanner);
  };

  const sendFeedbackHandler = (e: any) => {
    modalContext?.displayModal(false);
    showSuccessBanner(!successBanner);
  };

  return (
    <>
      {successBanner ? (
        <ModalContentWrapper
          removeCancelIcon
          title={successBanner ? null : 'Report Issue'}
          width={'43.875rem'}
          customToggler={sendFeedbackHandler}
        >
          <SuccessBanner>
            <div>
              <SuccessCheckMarkIcon />
              <p>Your report has been sent and will be reviewed</p>
            </div>
            <SendFeedBtn>
              <PrimaryButton onClick={sendFeedbackHandler}>
                Send feedback
              </PrimaryButton>
            </SendFeedBtn>
          </SuccessBanner>
        </ModalContentWrapper>
      ) : (
        <ModalContentWrapper
          title={successBanner ? null : 'Report Issue'}
          width={'43.875rem'}
        >
          <FormComponent
            initialValues={reportIssueInitialValues}
            schema={ReportIssueSchema}
            onSubmit={onSubmit}
            className="column col-smallscreen"
          >
            <TextInputField
              label="Package ID"
              name="trackingId"
              type="text"
              placeholder="#000001"
            />

            <TextAreaInputField
              label="Reason for Rejection"
              name="reason"
              type="text"
              placeholder="Why are you rejecting this package?"
            />

            <FormSubmitButton type="submit">Send Report</FormSubmitButton>
          </FormComponent>
        </ModalContentWrapper>
      )}
    </>
  );
};

export default ReportIssueModal;

const SuccessBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 3.25rem;
  margin: 6rem auto;

  & > * {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3.25rem;
  }

  & > * > p {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 140%;
    text-align: center;
  }

  @media (max-width: 480px) {
    margin: 1rem;
    gap: 6rem;
  }
`;

const SendFeedBtn = styled.div`
  display: none;
  color: red;

  @media (max-width: 480px) {
    display: block;
  }
`;
